import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/life-sciences-translation/page.tsx");
